import type { Sobre } from "../../shared/types";

// Área de práctica seleccionada globalmente por el ADMINISTRADOR (selector
// del Header) — se centraliza acá para no tener que agregar `?area=` a cada
// página de listado/dashboard individualmente. El backend ignora este query
// param para cualquier rol que no sea ADMINISTRADOR (ver middleware/auth.ts).
let areaGlobalSeleccionada: string | null = null;

export function establecerAreaGlobal(id: string | null) {
  areaGlobalSeleccionada = id;
}

export class ErrorApi extends Error {
  codigo: string;
  detalles?: unknown;
  status: number;

  constructor(
    codigo: string,
    mensaje: string,
    status: number,
    detalles?: unknown,
  ) {
    super(mensaje);
    this.codigo = codigo;
    this.status = status;
    this.detalles = detalles;
  }
}

async function solicitud<T>(ruta: string, opciones?: RequestInit): Promise<T> {
  const respuesta = await fetch(`/api${ruta}`, {
    credentials: "include",
    headers:
      opciones?.body && !(opciones.body instanceof FormData)
        ? { "Content-Type": "application/json", ...opciones?.headers }
        : opciones?.headers,
    ...opciones,
  });

  let sobre: Sobre<T>;
  try {
    sobre = await respuesta.json();
  } catch {
    throw new ErrorApi(
      "ERROR_RED",
      "No se pudo interpretar la respuesta del servidor.",
      respuesta.status,
    );
  }

  if (!sobre.exito) {
    throw new ErrorApi(
      sobre.error.codigo,
      sobre.error.mensaje,
      respuesta.status,
      sobre.error.detalles,
    );
  }
  return sobre.datos;
}

function conAreaGlobal(ruta: string): string {
  if (!areaGlobalSeleccionada) return ruta;
  const separador = ruta.includes("?") ? "&" : "?";
  return `${ruta}${separador}area_practica_id=${encodeURIComponent(areaGlobalSeleccionada)}`;
}

export const api = {
  get: <T>(ruta: string) => solicitud<T>(conAreaGlobal(ruta)),
  post: <T>(ruta: string, cuerpo?: unknown) =>
    solicitud<T>(ruta, {
      method: "POST",
      body: cuerpo ? JSON.stringify(cuerpo) : undefined,
    }),
  put: <T>(ruta: string, cuerpo?: unknown) =>
    solicitud<T>(ruta, {
      method: "PUT",
      body: cuerpo ? JSON.stringify(cuerpo) : undefined,
    }),
  patch: <T>(ruta: string, cuerpo?: unknown) =>
    solicitud<T>(ruta, {
      method: "PATCH",
      body: cuerpo ? JSON.stringify(cuerpo) : undefined,
    }),
  delete: <T>(ruta: string) => solicitud<T>(ruta, { method: "DELETE" }),
  subirArchivo: <T>(ruta: string, formData: FormData) =>
    solicitud<T>(ruta, { method: "POST", body: formData }),
};
